/**
 * Loại cột - xác định editor
 */
export default {
  Text: 0,
  Combobox: 1,
  Number: 2,
  Checkbox: 3,
  Datepicker: 5,
  Dropdown: 6,
  Template: 7,
  TextArea: 8,
  Enum: 9,
  Action: 10,
  State: 11,
  ComboboxMultiple: 12,
  DateRange: 13,
  CellCheckboxState: 14,
  ComboboxTree: 15,
  TextCenter: 16,
  GroupRadioButton: 17,
};
